// extracted by mini-css-extract-plugin
export var addButton = "_dm-4";
export var contentBlockImage = "_dm-i";
export var contentBlockWidgetPreview = "_dm-g";
export var fulfillmentCutoffWidgetPreview = "_dm-9";
export var imageBackdrop = "_dm-6";
export var imageIcon = "_dm-8";
export var lowProfileImageContainer = "_dm-b";
export var lowProfileImageIcon = "_dm-f";
export var lowProfileImageIconContainer = "_dm-e";
export var lowProfileImagePlaceholder = "_dm-d";
export var lowProfileProductImage = "_dm-c";
export var lowProfileProductUpsellWidgetPreview = "_dm-a";
export var productCard = "_dm-5";
export var productImage = "_dm-7";
export var productReviewsWidgetPreview = "_dm-h";
export var progressBar = "_dm-1";
export var progressBarFill = "_dm-2";
export var progressBarTrack = "_dm-3";
export var shippingOptionWidgetPreview = "_dm-j";
export var shippingUpsellProgressBar = "_dm-k";
export var thresholdUpsellWidgetPreview = "_dm-0";